export default __webpack_public_path__ + "static/media/maintenance@2x.cb6e7dd0.png";